export var CARD_TYPES = {
  primary: 'primary',
  secondary: 'secondary'
};